var _window$document;
import React from 'react';
import PropTypes from 'prop-types';

// Render content only on client side
import { jsx as ___EmotionJSX } from "@emotion/core";
export var isClientSide = typeof window !== 'undefined' && ((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.createElement);
var ClientSide = _ref => {
  var children = _ref.children;
  return ___EmotionJSX(React.Fragment, null, isClientSide && children);
};
ClientSide.propTypes = {
  children: PropTypes.node.isRequired
};
export default ClientSide;